@if (menu) {
  <div class="dropdown__root relative cursor-pointer py-1.25 font-normal">
    <strong class="space-x-xs whitespace-nowrap pb-3 font-medium">
      <span class="hidden lg:inline">{{ menu.title }}</span>
      <fa-icon [icon]="dropdownIcon"></fa-icon>
    </strong>
    @if (menu.children.length) {
      <cft-dropdown-navigation>
        @for (menuItem of menu.children; track menuItem; let i = $index) {
          <cft-dropdown-menu-item [icon]="menuItem.icon" [link]="menuItem.link">
            {{ menuItem.title }}
            @if (menuItem.children && menuItem.children.length) {
              <cft-dropdown-submenu
                [position]="{
                  index: i + 1,
                  parentElementsCount: menu.children.length,
                  subElementsCount: menuItem.children.length
                }"
                dropdownSubMenu
              >
                @for (subMenuItem of menuItem.children; track subMenuItem) {
                  <cft-dropdown-menu-item [icon]="subMenuItem.icon" [link]="subMenuItem.link">
                    {{ subMenuItem.title }}
                  </cft-dropdown-menu-item>
                }
              </cft-dropdown-submenu>
            }
          </cft-dropdown-menu-item>
        }
      </cft-dropdown-navigation>
    }
  </div>
}
